import { ErrorActions, ErrorButton, ErrorContainer, ErrorHeader, ErrorIconImage, ErrorTitle } from './Error.styles';
import { ErrorProps } from './Error.types';

const ERROR_ICON_URL = 'https://oneportal.vodafone.com/cdn/project/source-web/icons/SourceHiFiLightIcons/warning.svg';

export default function Error({ title, actions }: ErrorProps) {
    const [primaryAction, secondaryAction] = actions;

    return (
        <ErrorContainer>
            <ErrorHeader>
                <ErrorIconImage src={ERROR_ICON_URL} alt="Error icon" />
                <ErrorTitle>{title}</ErrorTitle>
            </ErrorHeader>
            <ErrorActions>
                {primaryAction && (
                    <ErrorButton type="button" onClick={primaryAction.onClick}>
                        {primaryAction.label}
                    </ErrorButton>
                )}
                {secondaryAction && (
                    <ErrorButton type="button" onClick={secondaryAction.onClick}>
                        {secondaryAction.label}
                    </ErrorButton>
                )}
            </ErrorActions>
        </ErrorContainer>
    );
}
